/**
 * Editor cue for an empty optional field: a muted purple that still meets
 * 4.5:1 on its surface, so the cue reads as a quiet invitation, not content.
 */
export const FIELD_CUE_COLORS = {
  /** On the light page (#ffffff). */
  light: '#7B5EA7',
  /** On the dark page (#1a171c). */
  dark: '#B9A6E0',
  /** On the kicker pill, which stays light in both themes. */
  onLight: '#7B5EA7',
  /** On a picture, behind the cue's backing (the phone's caller line). */
  onDark: '#B9A6E0',
  /** On the link button's light purple fill (#ece0ff), in both themes. */
  onTint: '#6E5299'
};

/** Opacity of the black backing a cue gets where it sits on a picture. */
export const FIELD_CUE_PICTURE_BACKING_OPACITY = 0.5;

/**
 * The help beside a cue, which says what its field is for: the editor's own
 * hint colors (its toolbar hints), the same over the light and the dark page.
 */
export const FIELD_HELP_COLORS = {
  text: '#ffffff',
  background: '#464646'
};
